var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ValidationObserver", { ref: "form", attrs: { slim: "" } }, [
    _c(
      "form",
      {
        staticClass: "form-horizontal",
        attrs: { role: "form", name: "vm.jornayaSetting", novalidate: "" },
        on: {
          submit: function($event) {
            $event.preventDefault()
          }
        }
      },
      [
        _c(
          "fieldset",
          [
            _c("Field", {
              attrs: {
                label: _vm.$t("ACCOUNT_CODE"),
                "has-tooltip": true,
                "tooltip-text": _vm.$t("ACCOUNT_CODE_TT")
              },
              scopedSlots: _vm._u([
                {
                  key: "element",
                  fn: function() {
                    return [
                      _c("ValidationProvider", {
                        ref: "accountCode",
                        attrs: { rules: "required", slim: "" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function({ classes }) {
                              return [
                                _c("div", { class: classes }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-sm-5 col-md-3" },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.jornayaSettingContext
                                                .accountCode,
                                            expression:
                                              "jornayaSettingContext.accountCode"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        attrs: { type: "text" },
                                        domProps: {
                                          value:
                                            _vm.jornayaSettingContext
                                              .accountCode
                                        },
                                        on: {
                                          input: [
                                            function($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                _vm.jornayaSettingContext,
                                                "accountCode",
                                                $event.target.value
                                              )
                                            },
                                            _vm.onInput
                                          ],
                                          change: _vm.onChange
                                        }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("label", {
                                    directives: [
                                      {
                                        name: "t",
                                        rawName: "v-t",
                                        value: "REQUIRED",
                                        expression: "'REQUIRED'"
                                      }
                                    ],
                                    staticClass:
                                      "col-sm-3 col-md-3 col-xs-2 form-group__label-required"
                                  })
                                ])
                              ]
                            }
                          }
                        ])
                      })
                    ]
                  },
                  proxy: true
                }
              ])
            }),
            _vm._v(" "),
            _c("Field", {
              attrs: {
                label: _vm.$t("AGENCY_CODE"),
                "has-tooltip": true,
                "tooltip-text": _vm.$t("AGENCY_CODE_TT")
              },
              scopedSlots: _vm._u([
                {
                  key: "element",
                  fn: function() {
                    return [
                      _c("ValidationProvider", {
                        ref: "agencyCode",
                        attrs: { rules: "required", slim: "" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function({ classes }) {
                              return [
                                _c("div", { class: classes }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-sm-5 col-md-3" },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.jornayaSettingContext
                                                .agencyCode,
                                            expression:
                                              "jornayaSettingContext.agencyCode"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        attrs: { type: "text" },
                                        domProps: {
                                          value:
                                            _vm.jornayaSettingContext.agencyCode
                                        },
                                        on: {
                                          input: [
                                            function($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                _vm.jornayaSettingContext,
                                                "agencyCode",
                                                $event.target.value
                                              )
                                            },
                                            _vm.onInput
                                          ],
                                          change: _vm.onChange
                                        }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("label", {
                                    directives: [
                                      {
                                        name: "t",
                                        rawName: "v-t",
                                        value: "REQUIRED",
                                        expression: "'REQUIRED'"
                                      }
                                    ],
                                    staticClass:
                                      "col-sm-3 col-md-3 col-xs-2 form-group__label-required"
                                  })
                                ])
                              ]
                            }
                          }
                        ])
                      })
                    ]
                  },
                  proxy: true
                }
              ])
            }),
            _vm._v(" "),
            _c("Field", {
              attrs: {
                label: _vm.$t("AUDIT_KEY"),
                "has-tooltip": true,
                "tooltip-text": _vm.$t("AUDIT_KEY_TT")
              },
              scopedSlots: _vm._u([
                {
                  key: "element",
                  fn: function() {
                    return [
                      _c("ValidationProvider", {
                        ref: "auditKey",
                        attrs: { rules: "required", slim: "" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function({ classes }) {
                              return [
                                _c("div", { class: classes }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-sm-5 col-md-3" },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.jornayaSettingContext
                                                .auditKey,
                                            expression:
                                              "jornayaSettingContext.auditKey"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        attrs: { type: "text" },
                                        domProps: {
                                          value:
                                            _vm.jornayaSettingContext.auditKey
                                        },
                                        on: {
                                          input: [
                                            function($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                _vm.jornayaSettingContext,
                                                "auditKey",
                                                $event.target.value
                                              )
                                            },
                                            _vm.onInput
                                          ],
                                          change: _vm.onChange
                                        }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("label", {
                                    directives: [
                                      {
                                        name: "t",
                                        rawName: "v-t",
                                        value: "REQUIRED",
                                        expression: "'REQUIRED'"
                                      }
                                    ],
                                    staticClass:
                                      "col-sm-3 col-md-3 col-xs-2 form-group__label-required"
                                  })
                                ])
                              ]
                            }
                          }
                        ])
                      })
                    ]
                  },
                  proxy: true
                }
              ])
            })
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }